<template>
  <master-layout pageTitle="Data Privacy">
    <div>
      <div class="chat-toolbar">
        <div class="toolbar-start">
          <VIcon name="arrow-left-line" :size="-4" @click="$router.push('/settings')" class="cursorPointer"></VIcon>
          <h2 class="vtext-page-title--regular vml-20">Data Privacy</h2>
        </div>
      </div>
      <div class="tabs-toolbar">
        <div class="tabs-row">
          <button type="button" :class="['tab-item', { active: activeTab === 'aboutDataRedact' }]" @click="changeTab('aboutDataRedact')">About Data Redact</button>
          <button type="button" :class="['tab-item', { active: activeTab === 'customerRedact' }]" @click="changeTab('customerRedact')">Customer Redact</button>
          <button type="button" :class="['tab-item', { active: activeTab === 'autoRedact' }]" @click="changeTab('autoRedact')">Auto Redact</button>
          <button type="button" :class="['tab-item', { active: activeTab === 'jobs' }]" @click="changeTab('jobs')">Jobs / History</button>
        </div>
      </div>
        <div v-if="activeTab === 'aboutDataRedact'">
          <div class="vgrid--no-padding gridMargin">
            <div class="vcol vcol--no-padding vcol-xl-8 vcol-lg-8 vcol-md-12 vcol-sm-12 vcol-xs-12 model-sections">
              <div class="sectionPadding cust-brdr">
                <h2 class="vtext-card-title--light">About Data Redact</h2>
              </div>
              <div class="sectionPadding">
                <div class="vtext-body redact-info">
                  <p class="marginBottom">Our Data Redact feature allows you to redact sensitive information from your data sets in our systems securely. With this feature, you can easily remove personal identifying information (PII) such as names, addresses, email ids, and mobile numbers from your data, while preserving the integrity of the remaining information.</p>
                  <p>This feature is essential for ensuring compliance with data protection regulations such as GDPR. With Data Redact, you can rest assured that your data is protected and that you are taking all necessary steps to safeguard the privacy of your customers.</p>
                  <p class="marginBottom"> We provide two solutions to cover your compliance and privacy needs: </p>
                  <div class="redact-table marginBottom">
                    <p class="title padding10P cust-brdr table-header">Customer Redact</p>
                    <div class="ion-no-margin title padding10P">
                        <p>Under GDPR (and other privacy laws and regulations), individuals have the right to have their personal data erased. Your users may ask you to remove any personal data being held about them. This could typically happen when someone terminates their relationship with an enterprise, for example, the user who no longer needs the service, and asks the enterprise to delete their account and all the information it holds about them. </p> 
                        <p>If your customer sends you a request to have personal data erased, you can use the Customer Redact to immediately remove personal identifying information (PII) such as names, addresses, email ids, and mobile numbers from your data, while preserving the integrity of the remaining information.</p>
                    </div>
                  </div>
                  <div class="redact-table marginBottom">
                    <p class="title padding10P cust-brdr table-header">Auto Redact (Paid Service)</p>
                    <div class="ion-no-margin title padding10P">
                        <p>The auto-redact feature will automatically run on a daily basis and redacts personal identifying information (PII) such as names, addresses, email ids, and mobile numbers from our systems without any intervention from your side. Our Auto-redact feature allows you to define the time frame of redaction based on the user's inactive status of 30 days, 60 days, or 90 days.</p> 
                        <p>To use the auto-redact feature, simply select the time frame related to the user's inactive status of 30 days, 60 days, or 90 days and our system will automatically scan your data sets and redact the personal identifying information (PII)  such as names, addresses, email ids, and mobile numbers from inactive user accounts, leaving the remaining data intact.</p>
                    </div>
                  </div>
                  <div class="info-box marginBottom">
                    <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
                    <p class="title ion-no-margin">The scope of redaction is not configurable and includes the following personal identifying information (PII) such as names, addresses, email ids, and mobile numbers.</p>  
                  </div>
                  
                  <p class="marginBottom"> The data redact process typically takes 2 hours to complete, as the service needs to thoroughly scan and redact all instances of sensitive information. We recommend not running or scheduling the broadcast during the data redaction window. </p>
                  <p v-if="EU_SERVER" class="marginBottom">The Auto-Redact will run daily at 12 AM Central European Time (CET) for the EU Instance.</p>
                  <p v-else class="marginBottom">The Auto-Redact will run daily at 12 AM Universal Time (UTC) for the US Instance.</p>

                  <p v-if="EU_SERVER">The EU instance employs a system where Server and Application log data are gradually replaced to retain only the most recent 30 days of logs. Redacting data will not affect the logs, as they are automatically overwritten every 30 days.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="activeTab === 'customerRedact'">
          <div class="vgrid--no-padding gridMargin">
            <div class="vcol vcol--no-padding vcol-xl-8 vcol-lg-8 vcol-md-12 vcol-sm-12 vcol-xs-12 model-sections">
              <div class="sectionPadding cust-brdr">
                <h2 class="vtext-card-title--light vpb-10">Customer Redact</h2>
                <p class="vtext-subtitle">Customer Redact allows you to promptly remove personal identifying information (PII) such as names, addresses, email addresses, and mobile numbers from your data while preserving the integrity of the remaining information.</p>
              </div>
              <div class="sectionPadding">
                <div class="vtext-body redact-info">
                  <div class="info-box marginBottom">
                    <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
                    <div>
                      <p class="vtext-body"> To redact customer data, follow these steps: </p>
                      <ul class="description_ul vtext-body">
                          <li>Download the customer list from the Customer section by clicking on "Customers" and then selecting "Export Customers"</li>
                          <li>Select the customers you wish to redact from the downloaded list and remove the others from the CSV file</li>
                          <li>Upload the file to the Customer Redact section</li>
                          <li>Confirm the redaction of the data</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="marginBottom">
                  <p class="vtext-subtitle vpb-10">File</p>
                  <div v-if="uploadCsvFileName == ''">
                    <VButton class="vvd-btn-secondary vvd-btn-block" connotation="cta" appearance="outlined" :label="isUploading ? 'Uploading...' : 'Upload File'" icon="clear-file-line" :disabled="isUploading" @click="() => isOpenImportModal = true"></VButton>
                  </div>
                  <div v-else class="uploadedFileContainer flexBetween width100P">
                    <div class="flex-start align-center">
                      <img src="../../resources/images/document_upload_img.svg" width="30" class="paddingRight" alt="document" />
                      <p class="vtext-body">{{ uploadCsvFileName }}</p>
                    </div>
                    <VIcon name="delete-line" connotation="alert" @click="() => {uploadCsvFileName = '', csvToUpload = null, isUploading = false;}" class="trashIcon cursorPointer"></VIcon>
                  </div>
                  <UploadCSVComponent v-if="isOpenImportModal" ref="UploadCSVComponent" type="dataRedact" name="Upload a file with customers" :isOpenImportModal="isOpenImportModal" @update:isOpenImportModal="(val) => isOpenImportModal = val" @uploadedFilePath="handleFileUpload" :showInstructions="true" :instructions="instructions" acceptTypes=".csv" :showDuplicateColumn="false" />
                </div>
                <form class="marginBottom">
                  <p class="vtext-subtitle vpb-10">Enter "DELETE" to confirm <span class="trashIcon">*</span></p>
                  <VTextField v-model="customerData_deleteText" placeholder="Enter DELETE" aria-label="Enter DELETE" appearance="ghost" class="vivid-input" :maxlength="6"></VTextField>
                </form>
                <VButton class="vvd-btn-primary vvd-btn-block" connotation="cta" appearance="filled" label="Confirm to delete data" @click="() => cutomerRedactAlert = true" :disabled="uploadCsvFileName == '' || customerData_deleteText !== 'DELETE'"></VButton>
              </div>
            </div>
          </div>
        </div>
        <div v-if="activeTab === 'autoRedact'">
          <div class="vgrid--no-padding gridMargin">
            <div class="vcol vcol--no-padding vcol-xl-8 vcol-lg-8 vcol-md-12 vcol-sm-12 vcol-xs-12 model-sections">
              <div class="sectionPadding cust-brdr">
                <h2 class="productTitle ion-no-margin paddingBottom">Auto Redact</h2>
                <h2 class="sub-title ion-no-margin ion-no-padding">The auto-redact feature will automatically run on a daily basis and redacts personal identifying information (PII) such as names, addresses, email ids, and mobile numbers from our systems without any intervention from your side.</h2>
              </div>
              <div class="sectionPadding">
                <div class="vtext-body redact-info">
                  <p class="marginBottom">Our Auto-redact feature allows you to define the redaction time frame based on user inactivity. You can choose from the default options of 30 days, 60 days, or 90 days, or set a custom inactivity period anywhere between 1 and 365 days.</p>
                  <div class="info-box marginBottom">
                    <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
                    <div>
                      <p class="vtext-body"> To use the Auto-Redact feature, follow these steps: </p>
                      <ul class="description_ul vtext-body">
                        <li>Enable the Auto-Redact Service</li>
                        <li>Select the redaction time frame based on the user's inactive status. You can choose from the default options of 30 days, 60 days, or 90 days, or set a custom inactivity period anywhere between 1 and 365 days. You can adjust this setting at a later time.</li>
                        <li>Confirm the redaction of the data</li>
                      </ul>
                    </div>
                  </div>
                  <p class="marginBottom">The data redact process typically takes 2 hours to complete, as the service needs to thoroughly scan and redact all instances of sensitive information. We recommend not running or scheduling the broadcast during the data redaction window.</p>  
                  <p v-if="EU_SERVER" class="marginBottom"> The Auto-Redact will run daily between 12:00am to 2:00am Central European Time (CET) for the EU Instance. </p>
                  <p class="marginBottom">If necessary, you can temporarily disable the Auto-Redact service using the Enable/Disable toggle button</p>
                </div>
                <div class="marginBottom">
                  <p class="vtext-subtitle vpb-10">Auto Redact Service<span class="trashIcon">*</span></p>
                  <div class="authContainer">
                    <div class="radio-option" :class="{ active: enableAutoRedactService === 'active' }" @click="enableAutoRedactService = 'active'">
                      <VIcon :name="enableAutoRedactService === 'active' ? 'radio-checked-line' : 'radio-unchecked-line'" :connotation="enableAutoRedactService === 'active' ? 'cta' : undefined"></VIcon>
                      <span class="vtext-body">Enable</span>
                    </div>
                    <div class="radio-option" :class="{ active: enableAutoRedactService === 'inactive' }" @click="enableAutoRedactService = 'inactive'">
                      <VIcon :name="enableAutoRedactService === 'inactive' ? 'radio-checked-line' : 'radio-unchecked-line'" :connotation="enableAutoRedactService === 'inactive' ? 'cta' : undefined"></VIcon>
                      <span class="vtext-body">Disable</span>
                    </div>
                  </div>
                </div>
                <div v-if="enableAutoRedactService === 'active'" class="marginBottom">
                  <div class="custom-days-container">
                    <div class="custom-container">
                      <p class="vtext-subtitle vpb-10">Redact based on X Days of user inactivity<span class="trashIcon">*</span></p>
                      <selectDropDown
                        :options="daysOptions"
                        :selectedValueProp="selectedDays"
                        placeholder="Select days"
                        @onSelectOption="({ selectedValue }) => selectedDays = selectedValue === 'custom' ? 'custom' : Number(selectedValue)"
                      />
                    </div>
                    <div v-if="selectedDays === 'custom'" class="custom-container">
                      <p class="vtext-subtitle vpb-10">Custom</p>
                      <div class="custom-input-row">
                        <VTextField
                          type="tel"
                          v-model="customDays"
                          placeholder="Enter days"
                          aria-label="Custom days"
                          appearance="ghost"
                          class="vivid-input custom-days-input"
                        ></VTextField>
                        <div class="days-subtext">
                          <p class="vtext-body">day(s)</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p v-if="selectedDays === 'custom' && customDays && (customDays < 1 || customDays > 365)" class="vtext-error vmt-5">Please enter a value between 1 and 365 days.</p>
                </div>
                <form v-if="enableAutoRedactService === 'active'" class="marginBottom">
                  <p class="vtext-subtitle vpb-10">Enter "DELETE" to confirm <span class="trashIcon">*</span></p>
                  <VTextField v-model="customerData_deleteText" placeholder="Enter DELETE" aria-label="Enter DELETE" appearance="ghost" class="vivid-input" :maxlength="6"></VTextField>
                </form>
                <VButton v-if="enableAutoRedactService === 'active'" class="vvd-btn-primary vvd-btn-block" connotation="cta" appearance="filled" label="Confirm to delete data" @click="autoRedactAlertData()" :disabled="customerData_deleteText !== 'DELETE' || (selectedDays === 'custom' && (!customDays || customDays < 1 || customDays > 365))"></VButton>
                <VButton v-if="enableAutoRedactService === 'inactive'" class="vvd-btn-primary vvd-btn-block" connotation="cta" appearance="filled" label="Save" @click="autoRedactAlertData()"></VButton>
              </div>
            </div>
          </div>
        </div>
        <div v-if="activeTab === 'jobs'">
          <div v-if="jobsListData.length > 0" class="gridMargin">
            <div class="model-sections">
              <div class="jobs-table-header">
                <div class="jobs-row">
                  <div class="jobs-cell"><span class="vtext-subtitle">Created on</span></div>
                  <div class="jobs-cell hide-mobile"><span class="vtext-subtitle">Completed on</span></div>
                  <div class="jobs-cell hide-mobile"><span class="vtext-subtitle">Created by</span></div>
                  <div class="jobs-cell hide-mobile"><span class="vtext-subtitle">Operation mode</span></div>
                  <div class="jobs-cell"><span class="vtext-subtitle">Customers redact stats</span></div>
                  <div class="jobs-cell text-right"><span class="vtext-subtitle">Status</span></div>
                </div>
              </div>
              <div v-for="(result, tIndex) in jobsListData" :key="tIndex" class="jobs-row cust-brdr sectionPadding">
                <div class="jobs-cell"><span class="vtext-body">{{ renderDateTime_lastReplyTimestamp(result.created_on, 'customReadable', false) }}</span></div>
                <div class="jobs-cell hide-mobile">
                  <span v-if="result.completed_on == '' || result.completed_on == 'None' || result.completed_on == null" class="vtext-body">-</span>
                  <span v-else class="vtext-body">{{ renderDateTime_lastReplyTimestamp(result.completed_on, 'customReadable', false) }}</span>
                </div>
                <div class="jobs-cell hide-mobile">
                  <p class="vtext-body vpb-5">{{ result.seller_name }}</p>
                  <p class="vtext-body">{{ result.seller_email }}</p>
                </div>
                <div class="jobs-cell hide-mobile">
                  <span class="vtext-body" v-if="result.mode =='csv'">Customer Redact</span>
                  <span class="vtext-body" v-else>Auto Redact</span>
                </div>
                <div class="jobs-cell">
                  <p class="vtext-body vpb-5"><b>Total customers to redact:</b> {{ result.total_users }}</p>
                  <p class="vtext-body vpb-5"><b>Successfully redacted:</b> {{ getSuccessfullyCountForthisLineItem(result.total_users, result.failed_users) }}</p>
                  <p class="vtext-body vpb-5"><b>Failed to redact:</b> {{ result.failed_users }}</p>
                  <VButton v-if="result.failed_users > 0" class="vvd-btn-secondary vmt-5" connotation="cta" appearance="outlined" icon="download-line" :label="loading_failedRedactCustomersMap[result.id] ? 'Downloading...' : 'Failed to redact customers list'" :disabled="loading_failedRedactCustomersMap[result.id]" @click="downloadFailedToRedactCustomers(result.id, result.seller_name)"></VButton>
                </div>
                <div class="jobs-cell text-right">
                  <span v-if="result.completed_on == '' || result.completed_on == 'None' || result.completed_on == null" class="vtext-body">{{ renderStatus_pendingOrInProgress(result) }}</span>
                  <span v-else class="vtext-body">Completed</span>
                </div>
              </div>
            </div>
            <div v-if="next && !transactionsLoadMore" class="text-center vmt-20">
              <VButton class="vvd-btn-secondary" connotation="cta" appearance="outlined" label="Load more" @click="fetch_jobsList()"></VButton>
            </div>
          </div>
          <div v-if="jobsListData.length == 0" class="text-center emptyContainer">
            <div>
              <img src="./../../resources/images/office_hours.svg" class="segmentImg" alt="no jobs"/>
              <h2 class="vtext-hero-title">No open jobs or history to show at the moment</h2>
              <p class="vtext-hero-subtitle">All open jobs and history will show up here!</p>
            </div>
          </div>
        </div>
      </div>
    <VDialog :open="cutomerRedactAlert" headline="Are you sure?" modal @close="() => cutomerRedactAlert = false">
      <template #body>
        <p class="vtext-body">You want to redact the data of customer(s) in the CSV?</p>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="() => cutomerRedactAlert = false"></VButton>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="customerRedactFile()"></VButton>
      </template>
    </VDialog>

    <!-- Auto Redact Confirmation -->
    <VDialog :open="autoDataRedact" headline="Are you sure?" modal @close="() => autoDataRedact = false">
      <template #body>
        <p class="vtext-body">{{ alertText }}</p>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="() => autoDataRedact = false"></VButton>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="sellerDataRedact_submit()"></VButton>
      </template>
    </VDialog>
  </master-layout>
</template>

<script>
import apiInterceptor from '@/shared/apiInterceptor';
import selectDropDown from '@/components/selectDropDown.vue';
import UploadCSVComponent from '@/components/upload-csv-component.vue';
import { useUIStore } from '@/stores/ui';
import { environment, isEuServer } from '@/shared/env';
import { renderDateTime_lastReplyTimestamp } from '@/helpers/date.helpers';

export default {
  components: { UploadCSVComponent, selectDropDown },
  data() {
    return {
      chevronUpOutline: 'chevron-up-line',
      addCircleOutline: 'add-line',
      arrowBackOutline: 'arrow-left-line',
      trashOutline: 'delete-line',
      createOutline: 'edit-line',
      documentOutline: 'clear-file-line',
      close: 'close-line',
      addOutline: 'plus-line',
      downloadOutline: 'download-line',
      closeCircleOutline: 'close-circle-line',
      storefrontOutline: 'store-line',
      informationCircleOutline: 'info-line',
      chevronDownOutline: 'chevron-down-line',
      isUploading: false,
      uploadCsvFileName: '',
      csvToUpload: null,
      customerData_deleteText: '',
      cutomerRedactAlert: false,
      autoDataRedact: false,
      selectedDays: 30,
      enableAutoRedactService: 'active',
      sellerDataRedact_existBool: false,
      alertText: '',
      jobsListData: [],
      more: undefined,
      cursor: null,
      activeTab: 'aboutDataRedact',
      loading_failedRedactCustomers: false,
      next: undefined,
      transactionsLoadMore: false,
      loading_failedRedactCustomersMap: {},
      isOpenImportModal: false,
      customDays: null,
      is_custom_scope: false,
      instructions: {
        ConversationID: "Conversation ID",
      },
      file_delimiter: '',
      skip_rows: 0,
      column_mapping: {}
    }
  },
  computed: {
    EU_SERVER() { return isEuServer(); },
    daysOptions() {
      return [
        { id: 30, value: 30, title: '30' },
        { id: 60, value: 60, title: '60' },
        { id: 90, value: 90, title: '90' },
        { id: 'custom', value: 'custom', title: 'Custom' },
      ];
    }
  },
  mounted() {
    this.sellerDataRedact_get();
    this.fetch_jobsList();
  },
  methods: {
    renderDateTime_lastReplyTimestamp,
    async doRefresh(event) {
      this.changeTab(this.activeTab);
      this.sellerDataRedact_get(event);
    },
    async changeTab(newTab) {
      this.activeTab = newTab;
    },
    async sellerDataRedact_get() {
      useUIStore().updateLoading({ isLoading: true });
      try {
        let redactDataResponse = await apiInterceptor.get(environment('VUE_APP_API_URL') + "crm/v1/redact/auto");
        let redactData = redactDataResponse;
        if(typeof redactData.redact_scope != 'undefined'){
          this.sellerDataRedact_existBool = true;
          this.is_custom_scope = redactData.is_custom_scope === true;
          if (this.is_custom_scope) {
            this.selectedDays = 'custom';
            this.customDays = redactData.redact_scope;
          } else {
            this.selectedDays = redactData.redact_scope;
          }
          this.enableAutoRedactService = redactData.status;
        }
        else{
          this.sellerDataRedact_existBool = false;
        }
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    handleFileUpload(data) {
      this.csvToUpload = data.filePath;
      this.uploadCsvFileName = data.fileName;
      this.file_delimiter = data.file_delimiter;
      this.skip_rows = data.skip_rows;
      this.column_mapping = JSON.parse(data.column_mapping);
    },
    async customerRedactFile() {
      try {
        if(this.customerData_deleteText == ''){
          return useUIStore().updateToast({ open: true, message: 'Please enter "DELETE" to confirm!', type: "danger" })
        }
        // Close the confirm dialog first so it doesn't sit on top of the loader.
        this.cutomerRedactAlert = false;
        useUIStore().updateLoading({ isLoading: true });
        const reqBody = new FormData();
        reqBody.append('file_object', this.csvToUpload);
        reqBody.append('file_delimiter', this.file_delimiter);
        reqBody.append('skip_rows', this.skip_rows);
        reqBody.append('column_mapping', JSON.stringify(this.column_mapping));
        await apiInterceptor.put( environment("VUE_APP_API_URL") + "crm/v1/redact/", reqBody, { headers: { "Content-Type": "multipart/form-data" } } );
        this.uploadCsvFileName = '';
        this.csvToUpload = null;
        this.isUploading = false;
        this.file_delimiter = '';
        this.skip_rows = 0;
        this.column_mapping = {};
        useUIStore().updateToast({ open: true, message: "Customer redact CSV file has been uploaded successfully!", type: "success", duration: 4000 });
        await this.fetch_jobsList();
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } 
      finally {
        useUIStore().updateLoading({ isLoading: false });
        this.customerData_deleteText = '';
        this.isUploading = false;
        this.cutomerRedactAlert = false;
      }
    },
    autoRedactAlertData(){
      const days = this.selectedDays === 'custom' ? this.customDays : this.selectedDays;
      if(this.enableAutoRedactService == 'active'){
        this.alertText = "you want to redact the platform data after every "+ days +" days ?";
      }
      else{
        this.alertText = "Do you want to deactivate auto redact service?";
      }
      this.autoDataRedact = true;
    },
    async sellerDataRedact_submit(){
      try {
        if(this.enableAutoRedactService === 'active' && this.customerData_deleteText == ''){
          return useUIStore().updateToast({ open: true, message: 'Please enter "DELETE" to confirm!', type: "danger" })
        }
        // Close the confirm dialog first so it doesn't sit on top of the loader.
        this.autoDataRedact = false;
        useUIStore().updateLoading({ isLoading: true });
        const isCustom = this.selectedDays === 'custom';
        const days = isCustom ? this.customDays : this.selectedDays;
        let reqBody = {};
        if(this.enableAutoRedactService === 'inactive'){
          reqBody['status'] = this.enableAutoRedactService;
        } else {
          reqBody = {
            inactivity_scope: days,
            is_custom_scope: isCustom
          };
        }
        if(this.sellerDataRedact_existBool ){
          //update
          var apiMethod = "put";
          if(this.enableAutoRedactService === 'active'){
            reqBody['status'] = this.enableAutoRedactService;
          }
        }
        else{
          //add
          apiMethod = "post";
        }
        await apiInterceptor[apiMethod]( environment("VUE_APP_API_URL") + 'crm/v1/redact/auto', reqBody );
        useUIStore().updateToast({ open: true, message: 'Auto Redact setting has been saved!', type: "success" });
        this.customerData_deleteText = '';
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } 
      finally {
        useUIStore().updateLoading({ isLoading: false });
        this.customerData_deleteText = '';
        this.autoDataRedact = false;
      }
    },
    async fetch_jobsList(e) {
      try {
        if(!e){
          useUIStore().updateLoading({ isLoading: true });
        }
        let reqBody = { limit: 15 };
        if (this.next) {
          reqBody.cursor = this.next;
        }
        const params = {
          ...reqBody
        }
        let jobListResponse = await apiInterceptor.get(environment('VUE_APP_API_URL') + "crm/v1/redact/transactions", { params });
        if (this.next && this.jobsListData.length > 0) {
          this.jobsListData = this.jobsListData.concat(jobListResponse.transactions);
        } else {
          this.jobsListData = jobListResponse.transactions;
        }
        this.next = jobListResponse.next_cursor;
        this.transactionsLoadMore = !this.next;
      } catch (error) {
        console.error("Exception", error);
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    getSuccessfullyCountForthisLineItem(total_users, failed_users) {
      if (typeof total_users !== 'undefined' && typeof failed_users !== 'undefined') {
        return parseInt(total_users) - parseInt(failed_users);
      }
      return 0;
    },
    renderStatus_pendingOrInProgress(data){
        if(typeof data != 'undefined'){
          var suceess_count = data.processed_users;
          var failed_count = data.failed_users;

          if(suceess_count + failed_count == 0){
              return "Pending";
          }
          else{
              return "In progress";
          }
        }
    },
    async downloadFailedToRedactCustomers(id, fileName) {
      try {
        this.loading_failedRedactCustomersMap = {
          ...this.loading_failedRedactCustomersMap,
          [id]: true
        };
        let reqBody = {
          transaction_id: id
        }
        const filename = `failed_conversation_${id}`;
        let response = await apiInterceptor.post(environment('VUE_APP_API_URL') + "crm/v1/redact/utility/failed-users", reqBody, { responseType: 'blob' });
        
        if (!(response instanceof Blob)) {
          throw new Error('Invalid response type. Expected a Blob.');
        }

        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error?.message || 'Something went wrong!', type: "danger" });
      } finally {
        // Clear loading state
        this.loading_failedRedactCustomersMap = {
          ...this.loading_failedRedactCustomersMap,
          [id]: false
        };
      }
    },
    openFileInput() {
      this.$refs.customerDataCsvFile.click();
    },
  }
}
</script>

<style lang="scss" scoped src="../../resources/css/settings.scss"> </style>

<style scoped>

.redact-info p{
  margin: 0px;
  line-height: 20px;
}

.status {
  background-color: var(--green);
  margin-left: 10px;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  display: inline-block !important;
}
.productTitle {
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: var(--black);
}
.sectionPadding{
  padding: 20px;
}
.redact-table{
  border: 1px solid var(--gray-04);
}
.table-header{
  background: var(--purple-opac);
  border-bottom: 1px solid var(--gray-04);
}
.padding10P{
  padding: 10px;
}
.marginBottom{
  margin-bottom: 20px !important;
}
.description_ul{
  margin: 5px 0px 0px 0px;
  padding-left: 20px;
}
.custom-days-container {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.custom-days-input {
  border-radius: 5px 0px 0px 5px !important;
}
.days-subtext{
  background: var(--gray-01);
  border-radius: 0px 5px 5px 0px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
.custom-container{
  display: flex;
  flex-direction: column;
  flex: 1;
}
.custom-input-row {
  display: flex;
  align-items: center;
  gap: 0px;
}

.chat-toolbar {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--white);
  border-bottom: 1px solid var(--background-primary);
}

.toolbar-start {
  display: flex;
  align-items: center;
}

.tabs-toolbar {
  position: sticky;
  z-index: 99;
  background: var(--white);
  border-bottom: 1px solid var(--background-primary);
}

.tabs-row {
  display: flex;
  width: 100%;
}

.tab-item {
  flex: 1;
  padding: 14px 10px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 14px;
  font-weight: 400;
  color: var(--black);
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  font-family: inherit;
  transition: border-color 0.2s, color 0.2s;
}

.tab-item:hover {
  color: var(--purple);
}

.tab-item.active {
  color: var(--purple);
  border-bottom-color: var(--purple);
  font-weight: 500;
}

.vivid-input {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
  width: 100%;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 5px 0;
}

/* Jobs Table */
.jobs-table-header {
  padding: 15px 20px;
  border-bottom: 1px solid var(--background-primary);
}

.jobs-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 2fr 1fr;
  align-items: center;
  gap: 10px;
}

.jobs-row.cust-brdr:last-child {
  border-bottom: none;
}

.jobs-cell {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hide-mobile { display: block; }
.show-mobile { display: none; }

@media only screen and (max-width: 760px) {
  .hide-mobile { display: none !important; }
  .show-mobile { display: block !important; }
  .jobs-row {
    grid-template-columns: 1fr 2fr 1fr;
  }
}

</style>